import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, AfterViewInit, OnChanges, SimpleChanges, Input, Output, SimpleChange } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Observable, concat, of, Subscription, Subject } from 'rxjs';
import { map, switchMap, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocListEntry } from 'src/app/shared/doc-list-entry';
import { Document } from 'src/app/shared/document';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-document-transaction-table',
  templateUrl: './document-transaction-table.component.html',
  styleUrls: ['./document-transaction-table.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentTransactionTableComponent implements OnInit, OnDestroy, OnChanges {

  private globalSettinsData: GlobalSettingsData;
  private transactionQuery: Subscription;

  loading: boolean = false;

  selectedDocType: number;

  docTransactionList: DocListEntry[];
  selectedDocument: DocListEntry;

  private docTransactionList$ = new Subject<number>();

  @Input()
  showAllTypes: boolean = false;

  @Input()
  inputDocumentId: number = 0;

  @Input()
  inputDocument: Document = null;

  constructor(
    private docApi: DocumentApiService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnDestroy(): void {
    console.log('*** DocumentTransactionTableComponent ngOnDestroy: ')

    if (this.transactionQuery) { this.transactionQuery.unsubscribe(); }

  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log('*** DocumentTransactionTableComponent ngOnDestroy: ')
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** DocumentTransactionTableComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** DocumentTransactionTableComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'inputDocumentId':
          console.log('*** DocumentTransactionTableComponent ngOnChanges ....: ' + change.currentValue)
          this.docTransactionList$.next(change.currentValue);
          break;

        case 'inputDocument':
          console.log('*** DocumentTransactionTableComponent ngOnChanges ....: ' + change.currentValue)
          this.docTransactionList$.next(change.currentValue.DOCID);
          break;
      }
    }
  }

  ngOnInit(): void {
    console.log('*** DocumentTransactionTableComponent ngOnInit: ')

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.transactionQuery =
      this.docTransactionList$.pipe(
        debounceTime(100),
        distinctUntilChanged(),
        switchMap((docId: number) => {
          console.log('*** DocumentTransactionTableComponent docTransactionList$ subscribing....: ' + docId)
          return this.docApi.getChildDocList(docId);
        })
      )
        .subscribe((data) => {

          console.log('*** DocumentTransactionTableComponent docTransactionList$ subscription: ')
          //environment.production || console.table(data);
          this.docTransactionList = data.filter(e => { return this.showAllTypes || [1, 2, 3, 4, 5, 8, 9, 11].includes(e.DOCTYPEID); } );
          //environment.production || console.table(this.docTransactionList);

          let jn: Date = new Date();
          let td: Date = new Date();
          td.setHours(0, 0, 0, 0);
          let tm: Date = new Date(td);
          tm.setHours(23, 59, 59);

          this.docTransactionList.forEach((dc: DocListEntry) => {
            dc.fs = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.SHIPSUM) < 0.02);

            dc.ps = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.SHIPSUM > 0) && ((dc.DOCSUM - dc.SHIPSUM) > 0.02);

            dc.fp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) < 0.02);

            dc.pp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.PAYDSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) > 0.02);

            dc.np = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && ((dc.SHIPSUM - dc.PAYDSUM) > 0.02);

            dc.go = (dc.DOCTYPEID == 1) && (new Date(dc.DOCVALDATE) < jn) && (dc.SHIPSUM == 0) && (dc.PAYDSUM == 0);

            dc.td = (new Date(dc.DOCDATE) > td) && (new Date(dc.DOCDATE) < tm);

            dc.fd = (new Date(dc.DOCDATE) > tm);
          });
        });
    this.reloadChildDocs(null);
  }

  reloadChildDocs(event) {
    console.log('*** DocumentTransactionTableComponent reloadChildDocs: ');

    this.docTransactionList$.next(0);
    setTimeout(() => {
      if (this.inputDocumentId) {
        this.docTransactionList$.next(this.inputDocumentId);
      }

      if (this.inputDocument) {
        this.docTransactionList$.next(this.inputDocument.DOCID);
      }
    }, 200);
  }
}
